<div
  class="flex w-screen max-w-screen gap-2"
  [style.height]="'calc(100svh - var(--env-banner-height, 0px))'"
  [style.maxHeight]="'calc(100svh - var(--env-banner-height, 0px))'"
>
  <div class="flex-none flex flex-col justify-between border-e border-slate-200">
    <p-menu [model]="this.navItems">
      <ng-template #start>
        <img
          src="pkvverlag_logo.png"
          class="m-[1rem]"
          style="height: 40px;"
        >
      </ng-template>
    </p-menu>
    <p-button
      severity="secondary"
      label="Logout"
      [text]="true"
      size="small"
      icon="pi pi-sign-out"
      [tabIndex]="0"
      class="logout-button"
      (onClick)="authService.logoutUserByUnsetToken()"
    />
  </div>
  <div class="flex-1 h-full w-full overflow-scroll p-3">
    <router-outlet></router-outlet>
  </div>
</div>